






import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Api from '../utils/Api';

@Component({
	components:{}
})
export default class Messages extends Vue {

	public messageList:{message:string, _id:string}[] = [];

	public mounted():void {
		Api.get("message").then(result=> {
			this.messageList = result.messages;
		})
	}

	public beforeDestroy():void {
		
	}

	public nl2br(message:string):string {
		return message.replace(/\r|\n/gi, "<br />");
	}

}
